module.exports = "https://portperrypedals.ca/_res/img/palmerpark.770deb9.jpg";